module.exports = __webpack_public_path__ + "static/media/bg.44d83f95.svg";